export default __webpack_public_path__ + "static/pragicts-secops-services-iam-c7377564b5049a97566de8f14c90b749.jpg";